<input type="hidden" name="gmtcid" id="gmtcid" value="{{gtm.currentContextId}}" />
<input type="hidden" name="gmtctypes" id="gmtctypes" value="{{gtm.contextTypes}}" />
<input type="hidden" name="gmtcctype" id="gmtcctype" value="{{gtm.currentContextType}}" />
<input type="hidden" name="gmtcusttype" id="gmtcusttype" value="{{gtm.customerType}}" />
<input type="hidden" name="gmtdistributor" id="gmtdistributor" value="{{gtm.distributor}}" />
<router-outlet></router-outlet>


